import React, { useEffect } from "react";
import { Box, Typography, List, ListItem } from "@mui/material";
import dayjs from "dayjs";

const NotificationList = ({ notifications }) => {
  const groupByDate = (data) => {
    return data.reduce((acc, activity) => {
      const date = formatDateString(activity.timestamp);
      acc[date] = [...(acc[date] || []), activity];
      return acc;
    }, {});
  };

  const formatDateString = (dateString) => {
    return dayjs(dateString).format("DD MMM YYYY");
  };

  const groupedNotifications = groupByDate(notifications);

  const getIcon = (type) => {
    const iconMap = {
      1: "useradd.svg",
      2: "info.svg",
      3: "comment.svg",
      4: "comment.svg",
      5: "uploaded.svg",
      6: "uploaded.svg",
      7: "uploaded.svg",
      8: "uploaded.svg",
      9: "info.svg",
      10: "uploaded.svg",
      11: "uploaded.svg",
      12: "uploaded.svg",
    };

    const src = iconMap[type] || "reportblue.svg";
    return (
      <img
        src={`assets/icons/${src}`}
        alt={src.replace(".svg", "")}
        width="20"
      />
    );
  };

  return Object.keys(groupedNotifications).map((date) => (
    <Box key={date}>
      <Box
        sx={{
          textAlign: "center",
          position: "relative",
          mt: 1,
          "&:before": {
            content: "''",
            position: "absolute",
            top: "10px",
            left: "16px",
            right: "16px",
            width: "calc(100% - 32px)",
            height: "1px",
            backgroundColor: "#D0D5DE",
          },
        }}
      >
        <Typography sx={{ width: "150px", backgroundColor: "#fff", position: "relative", zIndex: 2, m: "0 auto", fontSize: 12 }}>
          {formatDateString(date)}
        </Typography>
      </Box>
      <List sx={{ pb: 0 }}>
        {groupedNotifications[date].map((activity, index) => (
          <ListItem key={index} sx={{ py: 0, display: "flex", mt: "3px" }}>
            {getIcon(activity.type)}
            <Typography sx={{ fontWeight: 700, mr: 0.5, ml: 1, fontSize: 12, minWidth: 120 }}>
              {`${activity.user.firstName} ${activity.user.lastName} (${activity.user.company})`}{" "}
            </Typography>
            <Typography sx={{ fontSize: 12 }}>{activity.message}</Typography>
          </ListItem>
        ))}
      </List>
    </Box>
  ));
};

export default NotificationList;
